import { queryString } from './urlHelper'
import history from '../utils/history'
import { REPORTHOST } from '../constants/common';
import ResizeObserver from 'resize-observer-polyfill';
import { get } from '../utils/restCall';

export function isMiniProgram() {
  return window['__wxjs_environment'] === 'miniprogram'
}

export function isAndroid() {
  const ua = navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

export function isMobile() {
  const ua = navigator.userAgent;
  return /Android|webOS|iPhone|iPod|iPad|Macintosh|BlackBerry/i.test(ua);
}

export function isIos() {
  const ua = navigator.userAgent;
  return /iPhone|iPod|iPad|Macintosh/i.test(ua);
}

export function isIPad() {
  const ua = navigator.userAgent;
  return /iPod|iPad/i.test(ua) || document.documentElement.clientWidth >= 600;
}

export function getScript(url, callback) {
  const head = document.getElementsByTagName('head')[0];
  const js = document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('src', url);
  head.appendChild(js);
  js.onload = function() {
    if (typeof callback === 'function') {
      callback();
    }
  }
}

export function getCookie(key) {
  /* 获取cookie参数*/
  const getCookie = document.cookie.replace(/[ ]/g, '');
  const arrCookie = getCookie.split(';');
  let tips; // 声明变量tips
  // eslint-disable-next-line no-unused-vars
  for (const item of arrCookie) {
    const arr = item.split('=');
    if (key === arr[0]) {
      tips = arr[1] || arr[2];
      if (!arr[1] && arr[2]) {
        tips = arr[2]// isHd==1的情况需要兼容，所以采用了arr[2]
      }
      break;
    }
  }
  return tips;
}

export function setCookie(key, val, time) {
  const date = new Date(); // 获取当前时间
  // 将date设置为n小时以后的时间
  date.setTime(date.getTime() + time * 3600 * 1000); // 格式化为cookie识别的时间
  const setDomain = window.location.href.includes('jd100.com') ? ';path=/;domain=jd100.com' : ';path=/';
  document.cookie = key + '=' + val + setDomain + ';expires=' + date.toGMTString();
}

export function removeCookie(key) {
  const date = new Date(); // 获取当前时间
  date.setTime(date.getTime() - 10000); // 将date设置为过去的时间
  const setDomain = window.location.href.includes('jd100.com') ? ';path=/;domain=jd100.com' : ';path=/';
  document.cookie = key + '=v' + setDomain + ';expires = ' + date.toGMTString(); // 设置cookie
}

/**
 * 将异步setState变成同步
 *
 * @param {*} state
 * @returns
 * @memberof Grade
 */
export function setStateAsync(state, that) {
  return new Promise((resolve) => {
    that.setState(state, resolve)
  });
}

/** 是否是计划课  */
export function isPlan(businessType) {
  if (!businessType) return false;

  return parseInt(Number(businessType) / 100) === 12;
}

/** 是否是定制学  */
export function isCustom(businessType) {
  if (!businessType) return false;

  return parseInt(Number(businessType) / 100) === 15;
}

/** 是否来自盒子  **/
export function initLocalToken() {
  const fromBox = queryString('from') === 'box'
  if (fromBox) {
    localStorage.setItem('from', 'box')
    const token = queryString('u_token')
    if (token) {
      setCookie('u_token', token, 1000)
    }
  } else {
    localStorage.removeItem('from')
  }
}

export function supportLegacyBrowsers() {
  if (!('ResizeObserver' in window)) {
    const _window = window
    _window.ResizeObserver = ResizeObserver
  }
}

export function go2(url) {
  if (isFromBox()) {
    const query = url.split('?')[1]
    if (url.includes('/v3/wrongbookdetail')) {
      url = '/v3/exercise' + (query ? `?${query}` : '')
    } else if (url.includes('/v3/exercise')) {
      url = '/v3/exercise/detail' + (query ? `?${query}` : '')
    } else if (url.includes('/v3/printlist')) {
      url = `/v3/exercise/printlist/${Date.now()}` + (query ? `?${query}` : '')
    }
    if (history.location.pathname !== `/box${url}`) {
      history.push(`/box${url}`)
    }
  } else {
    history.push(url)
  }
}

export function exitBox() {
  const android = window.android
  if (android && typeof android.logout === 'function') {
    android.logout()
  }
}

export function exitApp() {
  const android = window.android
  if (android && typeof android.exitApp === 'function') {
    android.exitApp()
  }
}

export function home() {
  const android = window.android
  if (android && typeof android.home === 'function') {
    android.home()
  }
}

export function isFromBox() {
  return localStorage.getItem('from') === 'box'
}

export function isHd() {
  return getCookie('isHd') === '1'
}

export function isNewVersion() {
  if (isIos()) {
    if (Number(getCookie('versionCode') >= 103)) {
      return true
    } else {
      return false
    }
  }
  if (isAndroid()) {
    if (isHd()) {
      if (Number(getCookie('versionCode') >= 176)) {
        return true
      } else {
        return false
      }
    } else {
      if (Number(getCookie('versionCode') >= 27)) {
        return true
      } else {
        return false
      }
    }
  }
}

export function isWrongBookApp() {
  return getCookie('u_from') === 'box'
}

/**
 * 获取视频封面
 * @param sectionId
 * @return url
 **/
export function getSectionVideoImageUrl(sectionId) {
  return 'http://ufile.jd100.com/etvxImage?sectionId=' + sectionId + '&vt=-3000';
}

export function needHackVideo() {
  const userAgent = (navigator && navigator.userAgent) || '';

  /* istanbul ignore next */
  if (userAgent) {
    if (userAgent.indexOf('MQQBrowser') > -1) {
      return true;
    }

    if (userAgent.indexOf('UBrowser') > -1) {
      return true;
    }
  }

  return false;
}

export function isX5() {
  const userAgent = (navigator && navigator.userAgent) || '';
  const ua = userAgent.toLocaleLowerCase();

  /* istanbul ignore next */
  if (ua) {
    if (ua.indexOf('tencenttraveler') > -1) {
      return true;
    }

    if (ua.indexOf('qqbrowse') > -1) {
      return true;
    }
  }

  return false;
}

// 学科code
export function subjectCode(subjectName) {
  if (!subjectName) {
    return false;
  }
  // const subjectInfo = [{'语文':1},{'数学':2},{'英语':3},{'物理':4},{'化学':5},{'生物':6},{'政治':9},{'历史':7},{'地理':8},{'科学':13}]
  let subjectCode = '';
  switch (subjectName) {
    case '语文':
      subjectCode = 1;
      break;
    case '数学':
      subjectCode = 2;
      break;
    case '英语':
      subjectCode = 3;
      break;
    case '物理':
      subjectCode = 4;
      break;
    case '化学':
      subjectCode = 5;
      break;
    case '生物':
      subjectCode = 6;
      break;
    case '历史':
      subjectCode = 7;
      break;
    case '地理':
      subjectCode = 8;
      break;
    case '政治':
      subjectCode = 9;
      break;
    case '科学':
      subjectCode = 13;
      break;
    default:
      subjectCode = 12;
  }

  return subjectCode;
}

// 视频开始上报
export function heartStart(param) {
  const params = {
    stype: 'heart_start',
    type: 'jdkt',
    listen_rand: param.listen_rand,
    user_name: param.user_id,
    user_id: param.user_id,
    client: 4,
    business_type: 10,
    course_type: 6,
    subject_id: param.subject_id,
    auth_type: 13, //
    step: 2, //
    step_name: '正常播放',
    sguid: -1,
    cguid: -1,
    lguid: -1,
    cellid: param.section_id,
    cellchild_id: param.section_id,
    cellchild_type: param.section_id,
    cellchild_ref: param.section_id,
    cellchild_ref_type: param.section_id,
    level: 2,
    is_back: 0,
    st_version: 2,
    training_id: -1,
    textbook_order: -1,
    is_offlinestudy: 0
  };
  uploadUserData(params)
}

// 视频开始上报
export function heartEnd(param) {
  const params = {
    stype: 'heart_end',
    type: 'jdkt',
    listen_rand: param.listen_rand,
    user_name: param.user_id,
    user_id: param.user_id,
    client: 4,
    business_type: 10,
    course_type: 6,
    subject_id: param.subject_id,
    auth_type: 13,
    step: 2,
    step_name: '正常播放',
    sguid: -1,
    cguid: -1,
    lguid: -1,
    cellid: param.section_id,
    cellchild_id: param.section_id,
    cellchild_type: param.section_id,
    cellchild_ref: param.section_id,
    cellchild_ref_type: param.section_id,
    level: 2,
    is_back: 0,
    usetime: param.use_time,
    st_version: 2,
    training_id: -1,
    textbook_order: -1,
    is_offlinestudy: 0
  };
  uploadUserData(params)
}

// 数据上报
export async function uploadUserData(param) {
  let counter = 0; // 上报失败后尝试上报最多3次
  const ts = Math.floor(Date.now() / 1000);
  const params = {
    time: ts
  };

  Object.assign(params, param);

  if (counter >= 3) {
    return false;
  }

  function reqFun() {
    get(REPORTHOST, params).then(() => {
      counter = 0;
    }).catch((err) => {
      console.log(err, 'error')
    });
  }

  return reqFun();
}

// 格式化播放时间
export const formatPlayTime = (paramsTime) => {
  if (!paramsTime || paramsTime === 0) return null
  const time = Math.floor(paramsTime / 1000)

  const h = Math.floor(time / 3600) // 时
  let m = Math.floor((time - h * 3600) / 60) // 分
  let s = time - h * 3600 - m * 60 // 秒

  if (m < 10) m = `0${m}`
  if (s < 10) s = `0${s}`
  if (h > 0) {
    return `${h}:${m}:${s}`
  }
  return `${m}:${s}`
}

// url转换为对象
export const getQueryParams = (url = window.location.href) => {
  const arg = url.substring(url.lastIndexOf('?') + 1, url.length);
  const argument = {};
  const args = arg.split('&');
  for (let i = 0; i < args.length; i++) {
    const tmp = args[i].split('=');
    argument[tmp[0]] = decodeURIComponent(tmp[1]);
  }
  return argument;
}

/**
 * 将对象转变为字符串格式
 * @param obj
 */
export function urlStringfy(obj) {
  return Object.keys(obj)
    .map((key) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
    })
    .join('&')
}
